module.exports = __webpack_public_path__ + "img/degustation.cbc7f3b6.png";